import React from 'react';
import Table from './table/Table';
import {observer, inject} from 'mobx-react'
import {cdn} from '../helpers/cdn';

const metadata = {
    icon: cdn('icons/frankerfacez.png'),
    title: 'Top FFZ Emotes',
    colorPrimary: '#52d3a9',
    colorSecondary: '#f6fcfa',
};

@inject('store') @observer
class FfzEmotes extends React.Component {

    render() {
        const {store} = this.props;
        const {items, status} = store.ffzEmotes;
        return (
            <Table tableMetadata={metadata} status={status} data={items} tableType="ffzEmotes"/>
        );
    }
}

export default FfzEmotes;



// WEBPACK FOOTER //
// ./src/app/components/FfzEmotes.js